(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ua-image-gallery"] && !Shopify.designMode) return;
  try {
    (() => {
  function init() {
    const source = document.getElementById('ua-gallery-template');
    const root = document.getElementById('product-details-with-gallery');
    if (!source || !root || root.dataset.uaGalleryReady) return;
    root.dataset.uaGalleryReady = 'true';
    let dialog, thumbs, index = 0, opener, oldOverflow, resetZoom = () => {};
    function show(i) {
      index = (i + thumbs.length) % thumbs.length;
      const selected = thumbs[index];
      const image = dialog.querySelector('.ua-gallery__image');
      resetZoom();
      image.src = selected.dataset.src;
      image.alt = selected.dataset.alt;
      dialog.querySelector('.ua-gallery__count').textContent = (index + 1) + ' / ' + thumbs.length;
      thumbs.forEach((button, j) => button.setAttribute('aria-pressed', String(j === index)));
      selected.scrollIntoView({block:'nearest', inline:'nearest'});
    }
    function create() {
      document.body.append(source.content.cloneNode(true));
      dialog = document.body.querySelector('dialog.ua-gallery:last-of-type');
      thumbs = Array.from(dialog.querySelectorAll('.ua-gallery__thumb'));
      thumbs.forEach((button, i) => button.addEventListener('click', () => show(i)));
      dialog.querySelector('.ua-gallery__close').addEventListener('click', () => dialog.close());
      dialog.querySelector('.ua-gallery__prev').addEventListener('click', () => show(index - 1));
      dialog.querySelector('.ua-gallery__next').addEventListener('click', () => show(index + 1));
      dialog.querySelectorAll('.ua-gallery__prev,.ua-gallery__next').forEach(button => button.hidden = thumbs.length < 2);
      const area = dialog.querySelector('.ua-gallery__image-area');
      const image = dialog.querySelector('.ua-gallery__image');
      image.draggable = false;
      let scale = 1, x = 0, y = 0, drag, suppressClick = false;
      function paint() {
        const rect = area.getBoundingClientRect();
        const ratio = image.naturalWidth / image.naturalHeight || 1;
        const width = Math.min(rect.width, rect.height * ratio);
        const height = width / ratio;
        const maxX = Math.max(0, (width * scale - rect.width) / 2);
        const maxY = Math.max(0, (height * scale - rect.height) / 2);
        x = Math.max(-maxX, Math.min(maxX, x));
        y = Math.max(-maxY, Math.min(maxY, y));
        image.style.transform = 'translate(' + x + 'px,' + y + 'px) scale(' + scale + ')';
        area.classList.toggle('is-zoomed', scale > 1);
      }
      resetZoom = () => { scale = 1; x = 0; y = 0; drag = null; area.classList.remove('is-dragging'); paint(); };
      function zoomAt(next, clientX, clientY) {
        const rect = area.getBoundingClientRect();
        const px = clientX - rect.left - rect.width / 2;
        const py = clientY - rect.top - rect.height / 2;
        const factor = next / scale;
        x = px - (px - x) * factor;
        y = py - (py - y) * factor;
        scale = next;
        if (scale === 1) { x = 0; y = 0; }
        paint();
      }
      image.addEventListener('click', e => {
        if (suppressClick) { suppressClick = false; return; }
        if (scale > 1) resetZoom(); else zoomAt(2.5, e.clientX, e.clientY);
      });
      area.addEventListener('pointerdown', e => {
        if (!e.isPrimary || (e.pointerType === 'mouse' && e.button !== 0)) return;
        suppressClick = false;
        drag = {id:e.pointerId, startX:e.clientX, startY:e.clientY, x, y, moved:false};
        image.setPointerCapture(e.pointerId);
      });
      area.addEventListener('pointermove', e => {
        if (!drag || drag.id !== e.pointerId) return;
        const dx = e.clientX - drag.startX, dy = e.clientY - drag.startY;
        if (Math.hypot(dx, dy) > 6) drag.moved = true;
        if (scale > 1 && drag.moved) {
          x = drag.x + dx; y = drag.y + dy;
          area.classList.add('is-dragging'); paint();
        }
      });
      function endDrag(e) {
        if (!drag || drag.id !== e.pointerId) return;
        const dx = e.clientX - drag.startX, dy = e.clientY - drag.startY;
        suppressClick = drag.moved;
        if (e.type !== 'pointercancel' && scale === 1 && Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy)) show(index + (dx < 0 ? 1 : -1));
        drag = null;
        area.classList.remove('is-dragging');
        if (image.hasPointerCapture(e.pointerId)) image.releasePointerCapture(e.pointerId);
      }
      area.addEventListener('pointerup', endDrag);
      area.addEventListener('pointercancel', endDrag);
      area.addEventListener('wheel', e => {
        e.preventDefault();
        zoomAt(Math.max(1, Math.min(4, scale * Math.exp(-e.deltaY * 0.002))), e.clientX, e.clientY);
      }, {passive:false});
      image.addEventListener('load', paint);
      window.addEventListener('resize', () => { if (dialog.open) paint(); });
      dialog.addEventListener('keydown', e => {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); show(index + (e.key === 'ArrowRight' ? 1 : -1)); }
      });
      dialog.addEventListener('close', () => { document.documentElement.style.overflow = oldOverflow; if (opener && opener.isConnected) opener.focus(); });
    }
    function open(target) {
      if (!dialog) create();
      const id = target.dataset.imageId;
      const path = url => new URL(url, location.href).pathname.replace(/_(?:[0-9]+x[0-9]*|x[0-9]+)(?:_crop_[a-z]+)?(?:@[0-9]x)?(?=\\.[^.]+$)/, '');
      const url = path(target.currentSrc || target.src);
      let selected = thumbs.findIndex(button => path(button.dataset.src) === url);
      if (selected < 0) selected = thumbs.findIndex(button => button.dataset.imageId === id);
      opener = target;
      oldOverflow = document.documentElement.style.overflow;
      dialog.showModal();
      document.documentElement.style.overflow = 'hidden';
      show(selected < 0 ? 0 : selected);
      dialog.querySelector('.ua-gallery__close').focus();
    }
    const images = root.querySelectorAll('#ProductPhotoImg, img.product_variant_image');
    images.forEach(image => {
      image.tabIndex = 0;
      image.setAttribute('role', 'button');
      image.setAttribute('aria-haspopup', 'dialog');
    });
    root.addEventListener('click', e => {
      const thumbnail = e.target.closest('#ProductThumbs a');
      if (thumbnail) {
        e.preventDefault(); e.stopImmediatePropagation();
        const main = root.querySelector('#ProductPhotoImg');
        const thumbImage = thumbnail.querySelector('img');
        if (main) {
          main.src = thumbnail.dataset.image || thumbnail.href;
          main.alt = thumbImage ? thumbImage.alt : main.alt;
          main.dataset.imageId = thumbnail.dataset.imageId || '';
          main.dataset.zoomImage = thumbnail.dataset.zoomImage || thumbnail.href;
        }
        return;
      }
      const image = e.target.closest('#ProductPhotoImg, img.product_variant_image');
      if (!image) return;
      e.preventDefault(); e.stopImmediatePropagation(); open(image);
    }, true);
    root.addEventListener('keydown', e => {
      if ((e.key === 'Enter' || e.key === ' ') && e.target.matches('#ProductPhotoImg, img.product_variant_image')) { e.preventDefault(); open(e.target); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
  } catch(e) { console.error(e); }
})();

})();
